<template>
  <div class="journal-entry-item pl-1 pt-1 mt-1">
    <v-row>
      <v-col class="image-col">
        <div class="image-wrapper d-flex justify-center align-center">
          <slot>
            <PersonIcon/>
          </slot>
        </div>
      </v-col>

      <v-col class="content-wrapper-col">
        <v-row>
          <v-col class="content-col">
            <span class="name">{{ name }}</span>
            <span class="type">{{ $t(types[type].text) }}</span>
            <div class="text">{{ content }}</div>
          </v-col>
          <v-col class="date-col text-right">
            <span class="label">
              {{ $t(timeFormatted.prefix) }} {{ timeFormatted.time }} {{ $t(timeFormatted.timeString) }}
            </span>
            <span class="icon">
              <component :is="types[type].icon"/>
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PersonIcon from "@/components/icons/PersonIcon";
import CalendarIcon from "@/components/icons/CalendarIcon";
import PhoneIcon from "@/components/icons/PhoneIcon";
import {computed, ref} from "@vue/composition-api";

export default {
  name: "JournalEntryComponent",
  components: {PhoneIcon, CalendarIcon, PersonIcon},
  props: {
    name: String,
    type: String,
    timestamp: Number,
    content: String
  },
  setup(props) {
    const types = {
      text: {
        text: 'lead.journal.text',
        icon: ''
      },
      appointment: {
        text: 'lead.journal.appointment',
        icon: 'CalendarIcon'
      },
      phoneCall: {
        text: 'lead.journal.phoneCall',
        icon: 'PhoneIcon'
      }
    }

    const currentTimestamp = ref(Date.now());
    setInterval(() => {
      currentTimestamp.value = Date.now()
    }, 1000);

    const timeFormatted = computed(() => {
      const msDiff = currentTimestamp.value - props.timestamp
      let dateString = {}
      if (msDiff < 60000) {
        dateString.time = Math.floor(msDiff / 1000)
        dateString.timeString = 'time.seconds'
        dateString.prefix = 'time.prefix'
      } else if (msDiff < 3600000) {
        dateString.time = Math.floor(msDiff / 60000)
        dateString.timeString = 'time.minutes'
        dateString.prefix = 'time.prefix'
      } else if (msDiff < 86400000) {
        dateString.time = Math.floor(msDiff / 3600000)
        dateString.timeString = 'time.hours'
        dateString.prefix = 'time.prefix'
      } else {
        dateString.time = new Date(props.timestamp).toLocaleDateString()
      }
      return dateString
    })
    return {types, timeFormatted}
  }
}
</script>

<style scoped lang="scss">
.journal-entry-item {

  //
  + .journal-entry-item {
    border-top: 1px solid #8EA2A8;
  }

    // Change grid gutter
  .row {
    margin: 0 -8px;

    .col {
      padding: 0 8px;

      &.image-col {
        flex: 0 0 64px;
        max-width: 64px;

        .image-wrapper {
          background-color: #8EA2A8;
          border-radius: 50%;
          overflow: hidden;
          width: 48px;
          height: 48px;

          img {
            max-width: 100%;
            height: auto;
          }
        }
      }

      &.content-col {
        padding-top: 8px;

        .name {
          font-size: 16px;
          font-weight: 700;
          line-height: 21px;
          padding-right: 8px;
        }

        .type {
          color: #878787;
          font-size: 16px;
          font-weight: 500;
          line-height: 21px;
        }

        .text {
          font-size: 16px;
          font-weight: 500;
          line-height: 21px;
          padding-top: 8px;
        }
      }

      &.date-col {
        flex: 0 0 130px;
        max-width: 130px;

        .label {
          position: relative;
          top: -2px;
          color: #8BCBB7;
          font-size: 13px;
          font-weight: 500;
          line-height: 17px;
        }

        .icon {
          margin-left: 8px;

          img, svg {
            max-width: 16px;
            height: auto;
          }
        }
      }
    }
  }
}
</style>
